import styled from "styled-components";
import { ptToVwConverter, mobileVwConverter } from "../../utils";
import { Grid, Button } from "@material-ui/core";

export const SupportContainer = styled.div`
  margin-top: ${ptToVwConverter(116)}vw;
  margin-left: ${ptToVwConverter(200)}vw;
  margin-right: ${ptToVwConverter(200)}vw;
  height: 100%;
  min-height: 100%;
  @media (max-width: 1024px) {
    margin: ${mobileVwConverter(120)}vw ${mobileVwConverter(50)}vw 0
      ${mobileVwConverter(50)}vw;
    padding: 0;
    height: auto;
  }
`;

export const SupportMain = styled.main`
  width: ${ptToVwConverter(890 + 250)}vw;
  margin-left: ${ptToVwConverter(86)}vw;
  margin-top: -11px;
  min-height: 300px;
  @media (max-width: 1024px) {
    width: 100%;
    margin-left: 0;
    margin-top: ${mobileVwConverter(45)}vw;
  }
`;

export const SupportTitle = styled.div`
  display: grid;
  align-items: center;
  color: #000;
  font-size: 20px;
  letter-spacing: 0.1rem;
  line-height: 2.6rem;
`;

export const SupportIntro = styled.div`
  margin-top: ${ptToVwConverter(10)}vw;
  margin-bottom: ${ptToVwConverter(70)}vw;
  color: #000;
  line-height: 3em;
  font-size: 14px;
  letter-spacing: 0.1rem;
  @media (max-width: 1024px) {
    margin-top: ${mobileVwConverter(30)}vw;
    margin-bottom: ${mobileVwConverter(70)}vw;
    letter-spacing: 0.05rem;
  }
`;

export const SupportItemWrapper = styled(Grid)`
  && {
    height: auto;
  }
`;

export const SupportItem = styled(Grid)`
  && {
    margin-bottom: ${ptToVwConverter(80)}vw;
    @media (max-width: 1024px) {
      margin-left: ${mobileVwConverter(50)}vw;
      margin-right: ${mobileVwConverter(50)}vw;
      margin-bottom: 0;
    }
  }
`;

export const ItemImageButton = styled(Button)`
  && {
    padding: 0;
    margin-bottom: ${ptToVwConverter(34.5)}vw;
    border: solid 1px #d4d4d4;
    width: 100%;
    border-radius: 0;
    @media (max-width: 1024px) {
      width: 100%;
      margin-bottom: 0;
      margin-bottom: ${mobileVwConverter(30)}vw;
    }
  }
`;

export const ItemImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: auto;
`;

export const ItemImageAlt = styled.div`
  border: solid 1px #d4d4d4;
  width: 100%;
  margin-bottom: ${ptToVwConverter(34.5)}vw;
  padding-top: ${(100 * 2) / 3}%;
  height: 0;
  @media (max-width: 1024px) {
    margin-bottom: ${mobileVwConverter(34.5)}vw;
  }
`;

export const ItemDescription = styled.div`
  width: 100%;
`;

export const ItemTitle = styled.div`
  letter-spacing: 0.1em;
  color: #000;
  font-size: 18px;
  margin-bottom: ${ptToVwConverter(16)}vw;
  @media (max-width: 1024px) {
    font-size: 14px;
    margin-bottom: ${mobileVwConverter(10)}vw;
  }
`;

export const ItemBody = styled.div`
  color: #4d4d4d;
  font-size: 12px;
  letter-spacing: 0.1rem;
  line-height: 2em;
  margin-bottom: ${ptToVwConverter(30)}vw;
  @media (max-width: 1024px) {
    margin-bottom: ${mobileVwConverter(40)}vw;
  }
`;

export const WebButtonWrapper = styled.div`
  @media (min-width: 1024px) {
    display: flex;
    justify-content: flex-end;
  }
`;

export const WebButton = styled(Button)`
  && {
    background-color: #000;
    border-radius: 0;
    height: 50px;
    width: 200px;
    color: #fff;
    &:hover {
      background-color: #000;
    }
    @media (max-width: 1024px) {
      width: ${mobileVwConverter(315)}vw;
      height: ${mobileVwConverter(100)}vw;
    }
  }
`;
